var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucPreviewImage = function SvgImageDucPreviewImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.008 15.05a7.042 7.042 0 1 0 0-14.084 7.042 7.042 0 0 0 0 14.084Zm0 .966A8.008 8.008 0 1 0 8.008 0a8.008 8.008 0 0 0 0 16.016Z",
    fill: "#000",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.008 15.05a7.042 7.042 0 1 0 0-14.084 7.042 7.042 0 0 0 0 14.084Zm0 .966A8.008 8.008 0 1 0 8.008 0a8.008 8.008 0 0 0 0 16.016Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.308 19.54a.483.483 0 0 1-.679.082l-8.128-6.382.596-.76 8.129 6.383c.21.164.246.468.082.678Z",
    fill: "#000",
    fillOpacity: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.996 8.08c0-.267.216-.483.483-.483h7.026a.483.483 0 1 1 0 .966H4.48a.483.483 0 0 1-.483-.483Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.993 12.076a.483.483 0 0 1-.483-.483V4.567a.483.483 0 1 1 .966 0v7.026a.483.483 0 0 1-.483.483Z",
    fill: "#000"
  })));
};
export default SvgImageDucPreviewImage;